/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/CustomJourneyTypePageQuery$parameters.ts';
import type { CustomJourneyTypePageQuery } from './__generated__/CustomJourneyTypePageQuery.graphql.ts';

type Queries = {
	jiraJourneyConfiguration: CustomJourneyTypePageQuery;
};

type CustomJourneyTypeEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const customJourneyTypeEntryPoint: EntryPoint<
	CustomJourneyTypeEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<CustomJourneyTypeEntryPointComponent>(
		/* webpackChunkName: "async-journeys-custom-journey", jiraSpaEntry: "async-journeys-custom-journey" */ './CustomJourneyTypePage.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			jiraJourneyConfiguration: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey || '',
					journeyTypeId: context.match.params.journeyTypeId ?? '',
					cloudIdAsString: tenantContext.cloudId,
				},
			},
		},
		entryPoints: {},
		extraProps: {},
	}),
});
